'use client'

import {useEffect, useState} from 'react'
import {LuWifiLow, LuWifiOff} from 'react-icons/lu'
import {FaXmark} from 'react-icons/fa6'
import {useIsConnectionWeak, useNetworkOnline} from '../../hooks/useNetworkOnline'

export function OfflineBanner() {
  const isOnline = useNetworkOnline()
  const isConnectionWeak = useIsConnectionWeak()
  const showOffline = !isOnline
  const showWeakConnection = isOnline && isConnectionWeak
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    setDismissed(false)
  }, [showOffline, showWeakConnection])

  if ((!showOffline && !showWeakConnection) || dismissed) {
    return null
  }

  const message = showOffline
    ? 'You are offline. Please check your internet connection.'
    : 'Your network connection is weak. The app may respond slowly.'
  const StatusIcon = showOffline ? LuWifiOff : LuWifiLow

  return (
    <div
      className={[
        'pointer-events-auto fixed inset-x-0 top-0 z-[100]',
        'border-b border-amber-200 bg-amber-50 px-3 py-2.5',
        'shadow-sm dark:border-amber-800 dark:bg-amber-950',
      ].join(' ')}
      role="alert"
      aria-live="polite"
    >
      <div className="mx-auto flex max-w-4xl items-center gap-3 sm:gap-4">
        <div className="flex shrink-0 items-center justify-center rounded-full bg-amber-100 p-1.5 dark:bg-amber-900/80">
        {/* @ts-ignore */}
          <StatusIcon
            className="h-5 w-5 text-amber-800 dark:text-amber-200"
            aria-hidden
          />
        </div>
        <p className="min-w-0 flex-1 text-sm font-medium text-amber-950 dark:text-amber-100">
          {message}
        </p>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className={[
            'inline-flex shrink-0 items-center gap-1 rounded-md',
            'border border-amber-300 bg-white px-2.5 py-1.5 text-sm font-medium text-amber-950 shadow-sm hover:bg-amber-50',
            'focus-visible:ring-2 focus-visible:ring-amber-600 focus-visible:ring-offset-2 focus-visible:outline-none',
            'dark:hover:bg-amber-800 dark:focus-visible:ring-amber-500 dark:focus-visible:ring-offset-amber-950',
            'dark:border-amber-700 dark:bg-amber-900 dark:text-amber-50',
          ].join(' ')}
          aria-label={showOffline ? 'Dismiss offline banner' : 'Dismiss weak connection banner'}
        >
          <span className="hidden sm:inline">Dismiss</span>
          {/* @ts-ignore */}
          <FaXmark
            className="h-4 w-4 sm:hidden"
            aria-hidden
          />
        </button>
      </div>
    </div>
  )
}
